// Search Results page — purely cosmetic active-tab highlighting. All actual
// filtering is native (the tabs are plain links to ?type=product /
// ?type=article); this only reads the current URL to mark which tab matches.
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('[data-search-tabs] [data-tab-type]');
  if (!tabs.length) return;

  const activeType = new URLSearchParams(window.location.search).get('type') || 'all';

  tabs.forEach((tab) => {
    tab.classList.toggle('is-active', tab.dataset.tabType === activeType);
  });
});
